import React, { useContext } from 'react';
import CARTSTATE_MODULE_DATA from 'organisms/CartStatesModule/Data/SampleData';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import CartStatesModuleForm from 'organisms/CartStatesModule/Presentation/CartStatesModuleForm';
import CartStatesModuleInsideModal from 'organisms/CartStatesModule/Presentation/CartStatesModuleInsideModal';

const ProductStatesModule = props => {
  const { unavailableItems, priceChangedItems, confirmChangesHandler, discardChangesHandler } = props;
  const { contentData = {} } = CARTSTATE_MODULE_DATA;
  const { modalContent = {} } = contentData;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { CART_STATES_DATA = '', ADD_TO_CART_CLICK = '' } = START_ORDER_CONSTANTS;

  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: false } });
    userOrderStateDispatch({
      type: ADD_TO_CART_CLICK,
      value: { addToCart: false },
    });
  };

  const onProductStateMethodSubmit = (event, type) => {
    event.stopPropagation();
    event.preventDefault();
    if (type === 'discardChanges') {
      discardChangesHandler();
    } else {
      confirmChangesHandler();
    }
  };

  const productStatesModuleForm = (
    <CartStatesModuleForm
      modalContent={modalContent}
      onCartStatesMethodSubmit={onProductStateMethodSubmit}
      unavailableItems={unavailableItems}
      priceChangedItems={priceChangedItems}
    />
  );
  return <CartStatesModuleInsideModal handleClose={handleClose} CartStatesModuleForm={productStatesModuleForm} />;
};

export default ProductStatesModule;
